import { render, staticRenderFns } from "./tabSpecialGoods.vue?vue&type=template&id=2b783d7c&"
import script from "./tabSpecialGoods.vue?vue&type=script&lang=js&"
export * from "./tabSpecialGoods.vue?vue&type=script&lang=js&"
import style0 from "./tabSpecialGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b783d7c')) {
      api.createRecord('2b783d7c', component.options)
    } else {
      api.reload('2b783d7c', component.options)
    }
    module.hot.accept("./tabSpecialGoods.vue?vue&type=template&id=2b783d7c&", function () {
      api.rerender('2b783d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoods.vue"
export default component.exports